import Svg, { ClipPath, Defs, G, LinearGradient, Path, Stop, SvgProps } from 'react-native-svg'

export const RoundLoadingTimer = (props: SvgProps) => {
  return (
    <Svg {...props} width={24} height={24} viewBox="0 0 24 24">
      <Defs>
        <LinearGradient id="prefix__b" x1={1} y1={-0.898} x2={0.401} y2={1} gradientUnits="objectBoundingBox">
          <Stop offset={0} stopOpacity={0.302} />
          <Stop offset={1} stopOpacity={0} />
        </LinearGradient>
        <ClipPath id="prefix__a">
          <Path d="M0 0h24v24H0z" fill="#fff" />
        </ClipPath>
      </Defs>
      <G clipPath="url(#prefix__a)">
        <Path
          d="M21 10.12h-6.78l2.74-2.82a7.039 7.039 0 00-9.88-.1 6.875 6.875 0 000 9.79 7.02 7.02 0 009.88 0A6.513 6.513 0 0019 12.1h2a9.341 9.341 0 01-2.64 6.29 9.054 9.054 0 01-12.72 0 8.84 8.84 0 01-.02-12.58 8.987 8.987 0 0112.65 0L21 3zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8z"
          fill="#0070b6"
        />
        <Path
          d="M150.56 100.838h2a10.872 10.872 0 01-.213 1.8 14.574 14.574 0 01-.766 2.142l-2.083-.205a8.753 8.753 0 00.92-2.216 8.079 8.079 0 00.142-1.521z"
          transform="translate(-131.562 -88.737)"
          fill="url(#prefix__b)"
        />
      </G>
    </Svg>
  )
}

export default RoundLoadingTimer
